{
  "words": [
    {
      "word": "Mama",
      "pronounce": "[Ma-ma]",
      "wordtype": "zelfstandig naamwoord",
      "description": "De vrouw die vanaf je geboorte onvoorwaardelijk van je houdt. Degene die haar kinderen voor zichzelf stelt. Ze is lief, geduldig en warm. Zij is de maker en bewaarder van dierbare herinneringen en degene op wie je altijd kunt rekenen."
    },
    {
      "word": "Papa",
      "pronounce": "[Pa-pa]",
      "wordtype": "zelfstandig naamwoord",
      "description": "De man met zilver in zijn haar en goud in zijn hart. Een zorgdrager, held, rolmodel en beschermer, die zichzelf vaak wegcijfert voor zijn gezin. Iemand die alles kan maken en repareren. Hij is taai en hard van buiten maar zacht en zorgzaam van binnen. <br/>Geeft de stevigste knuffels."
    },
    {
      "word": "Juf",
      "pronounce": "[Juf]",
      "wordtype": "zelfstandig naamwoord",
      "description": "Iemand die lesgeeft aan kinderen. Ze inspireert en helpt ze groeien, ze heeft ogen in haar rug, is geduldig en helpt kinderen om de beste versie van zichzelf te zijn. Een lieve en goede juf laat een levenslange indruk achter in je hart."
    },
    {
      "word": "Meester",
      "pronounce": "[Mees-ter]",
      "wordtype": "zelfstandig naamwoord",
      "description": "Iemand die lesgeeft aan kinderen. Hij inspireert en helpt ze groeien, hij heeft ogen in zijn rug, is geduldig en helpt kinderen om de beste versie van zichzelf te zijn. Een grappige en goede meester laat een levenslange indruk achter in je hart."
    },
    {
      "word": "Bedgasm",
      "pronounce": "[Bed-gas-um]",
      "wordtype": "noun",
      "description": "The feeling of euphoria you get when lying down in your bed after a very long day."
    },
    {
      "word": "Hangry",
      "pronounce": "[Han-gry]",
      "wordtype": "adj.",
      "description": "Irritable or angry because of hunger. A state of being. Never argue with a person who is hangry, there is no chance of winning the argument. People suffering from 'hangriness' can't be held responsible for his or her actions due to the fact that they haven't been fed properly."
    },
    {
      "word": "Tante",
      "pronounce": "[Tan-te]",
      "wordtype": "zelfstandig naamwoord",
      "description": "Een absolute vertrouweling en unieke metgezel voor het leven waarop je altijd kunt vertrouwen. Ze bewaart geheimen als een zus en deelt de mooiste momenten als een beste vriendin. Met haar kun je paarden stelen en alle spannende avonturen beleven die te gevaarlijk zijn voor mama. Net als een moeder, alleen cooler en met minder regels."
    },
    {
      "word": "Oom",
      "pronounce": "[Oom]",
      "wordtype": "zelfstandig naamwoord",
      "description": "Iemand die je helpt kattenkwaad uit te halen en je altijd aan het lachen zal maken, de adviseur, de hulp en de beschermer, een bron van grenzeloos plezier en gelach. Degene die geduldig, genereus en vriendelijk is, een man die wordt gewaardeerd en Bestseller."
    },
    {
      "word": "Opa",
      "pronounce": "[O-pa]",
      "wordtype": "zelfstandig naamwoord",
      "description": "De man van wie je alles leren kunt, die in elke situatie raad weet en altijd passende wijsheid paraat heeft. Hij kan alles repareren, iets wat zelfs papa niet kon. Hij houdt meer van zijn kleinkinderen dan van wat dan ook. Hij heeft de gekste ideeën en is de grootste grappenmaker. Voor de hele familie is hij een bron van liefde en geborgenheid."
    },
    {
      "word": "Oma",
      "pronounce": "[O-ma]",
      "wordtype": "zelfstandig naamwoord",
      "description": "Een vrouw met een hart van goud. Die meer dan wat dan ook van haar kleinkinderen houdt en al hun geheimen bewaart. Ze vindt het heerlijk om snoep, kusjes, knuffels en heel veel liefde uit te delen. Ze is de beste bakker ter wereld en laat je nooit zonder volle buik naar huis gaan."
    },
    {
      "word": "Broer",
      "pronounce": "[Broer]",
      "wordtype": "zelfstandig naamwoord",
      "description": "Een man met dezelfde vader en/of moeder, beschermer, degene die weet hoe hij je aan het lachen kan maken, iemand die je met de jaren steeds meer waardeert. Degene die er altijd is om te helpen, een beste vriend voor het leven."
    },
    {
      "word": "Zus",
      "pronounce": "[Zus]",
      "wordtype": "zelfstandig naamwoord",
      "description": "Een vrouw met dezelfde vader en/of moeder, beschermer, degene die een band deelt die niemand anders begrijpt, een bewaarder van geheimen, altijd klaar om te helpen, door dik en dun. Een beste vriendin voor het leven die meer Bestseller is dan ze ooit zal weten."
    },
    {
      "word": "Dad",
      "pronounce": "[Dad]",
      "wordtype": "noun",
      "description": "The one with silver in his hair and gold in his heart. A provider, hero, role model and protector, who sacrifices his own needs for those of his family. One who can fix anything. He is tough on the outside and soft on the inside. <br/>Giver of the best bear hugs."
    },
    {
      "word": "Heit",
      "pronounce": "[Heit]",
      "wordtype": "haadwurd",
      "description": "De man mei sulver yn it hier en goud yn it hert. In fersoarger, held, rolmodel en beskermer, dy't himsels faaks weisifert foar syn famylje. Ien dy't alles meitsje en reparearje kin. Hy is stoer en hurd fan bûten, mar sêft en soarchsum fan binnen. <br/>Jout de sterkste knuffels."
    },
    {
      "word": "Daughter",
      "pronounce": "[Daugh-ter]",
      "wordtype": "noun",
      "description": "One of the most beautiful girls this world has to give. She is a little girl who grows up to be your best friend. Somewone who laugh with, you dream with, and love with all your heart."
    },
    {
      "word": "Dochter",
      "pronounce": "[Doch-ter]",
      "wordtype": "zelfstandig naamwoord",
      "description": "Een van de mooiste meisjes die deze wereld te bieden heeft. Ze is een klein meisje dat opgroeit tot je beste vriendin. Iemand met wie je lacht, waarmee je droomt en iemand die liefhebt met heel je hart."
    },
    {
      "word": "Gezellig",
      "pronounce": "[Ge-zel-lig]",
      "wordtype": "bijvoeglijk naamwoord",
      "description": "Een ongrijpbaar geluksmoment voortkomend uit de omgeving of staat waar iemand zich in bevindt. Wanneer het met elkaar beter is dan zonder elkaar kun je pas echt spreken van gezelligheid."
    },
    {
      "word": "Grandma",
      "pronounce": "[Grand-ma]",
      "wordtype": "noun",
      "description": "A woman with a heart of gold. Who loves her grandchildren more than anything and keeps their secrets. She loves to give out sweets, kisses, hugs and lots of love. She is the best baker in the world and will never let you go home without a full belly."
    },
    {
      "word": "Grandpa",
      "pronounce": "[Grand-pa]",
      "wordtype": "noun",
      "description": "The man from whom you can learn everything, who knows what to do in every situation and who always has appropriate wisdom. He can fix anything, something even Dad couldn't fix. He loves his grandchildren more than anything else. He has the craziest ideas and is the greatest prankster. He is a source of love and security for the whole family."
    },
    {
      "word": "Liefde",
      "pronounce": "[Lief-de]",
      "wordtype": "zelfstandig naamwoord",
      "description": "Liefde is diepe acceptatie van en genegenheid voor, welgezindheid tot of toewijding voor een ander, of eventueel zichzelf. Het kan ook betrekking hebben op een dier, zaak of voorwerp. Een schat gaat niet altijd over geld, maar wordt soms ook als liefde geteld. Elkaar begrijpen zonder een woord dat is echt liefde, dat is wat hoort."
    },
    {
      "word": "Love",
      "pronounce": "[Love]",
      "wordtype": "noun",
      "description": "Love is deep acceptance of and affection for, benevolence towards or devotion to another, or possibly oneself. It can also refer to an animal, thing or object. A treasure is not always about money, but sometimes it is also counted as love. Understanding each other without a word that's really love, that's what it should be."
    },
    {
      "word": "Schatje",
      "pronounce": "[Schat-je]",
      "wordtype": "zelfstandig naamwoord",
      "description": "Een koosnaam voor je vriend, vriendin, een bestie, iemand waarmee je echt goed op kunt schieten. Het is iemand waarmee je een goede band hebt. Je begrijpt elkaar heel goed. Schatje is een verklein woord van schat."
    },
    {
      "word": "Son",
      "pronounce": "[Son]",
      "wordtype": "noun",
      "description": "A priceless asset to the family. And not just because he can eat more in a day than he weighs. Prefers to communicate with a series of unintelligible sounds. But at the same time, he brings so much love, pride and good humor that you can never blame him."
    },
    {
      "word": "Zoon",
      "pronounce": "[Zoon]",
      "wordtype": "zelfstandig naamwoord",
      "description": "Een onbetaalbare aanwinst voor de familie. En niet alleen omdat hij op een dag meer kan eten dan hij zelf weegt. Geeft er de voorkeur aan om te communiceren met een reeks onverstaanbare geluiden. Maar tegelijkertijd brengt hij zoveel liefde, trots en goed humeur met zich mee dat je hem nooit de schuld kunt geven."
    },
    {
      "word": "Aunt",
      "pronounce": "[Aunt]",
      "wordtype": "noun",
      "description": "An absolute confidant and unique companion for life that you can always rely on. She keeps secrets like a sister and shares the best moments like a best friend. With her you can steal horses and experience all the exciting adventures that are too dangerous for mom. Just like a mom, only cooler and with fewer rules."
    },
    {
      "word": "Familie",
      "pronounce": "[Fa-mi-lie]",
      "wordtype": "zelfstandig naamwoord",
      "description": "Mensen die elkaar kennen, elkaar vertrouwen en elkaar altijd steunen. Ook al liggen liefde en chaos hier soms dicht bij elkaar, het blijft de plek waar het hart thuis is. Ze geeft wortels en vleugels en is er voor elkaar, in goede en slechte tijden, en levenslang."
    },
    {
      "word": "Beppe",
      "pronounce": "[Bè-pu]",
      "wordtype": "haadwurd",
      "description": "In frou mei in hert fan goud. Dy 't mear as wat dan ek fan har bernsbern hâldt en har geheimen bewarret. Se fynt it hearlik om snobbersguod, tútsjes, knuffels en in hiel soad leafde út te dielen. Se is de bêste bakker fan 'e wrâld en lit dy noait sûnder folle búk nei hûs ta gean."
    },
    {
      "word": "Family",
      "pronounce": "[Fa-mi-ly]",
      "wordtype": "noun",
      "description": "People who know each other, trust each other and always support each other. Even though love and chaos are sometimes close together here, it remains the place where the heart is at home. She gives roots and wings and is there for each other, in good times and bad, and for life."
    },
    {
      "word": "Brother",
      "pronounce": "[Bro-ther]",
      "wordtype": "noun",
      "description": "A man with the same father and/or mother, protector, the one who knows how to make you laugh, someone who appreciates you more and more with age. The one who is always there to help, a best friend for life."
    },
    {
      "word": "Cheers",
      "pronounce": "[Cheers]",
      "wordtype": "interjection",
      "description": "Is pronounced when confirming the congratulations with a toast, that is, drinking to one's well-being, including good health. Then the toast is confirmed by raising the glass or clinking it; first tapping the filled own drinking glass against someone else's filled glass. A sip is taken while saying the word 'cheers'."
    },
    {
      "word": "Proost",
      "pronounce": "[Proost]",
      "wordtype": "tussenwerpsel",
      "description": "Wordt uitgesproken bij het bevestigen van de heilwens met een heildronk, dat wil zeggen dat men drinkt op iemands welzijn, waaronder de goede gezondheid. Daarna wordt de heildronk bevestigd door het glas te heffen of door te klinken; het gevulde eigen drinkglas eerst tegen een andermans gevulde glas te tikken. Er wordt onder het uitspreken van het woord 'proost' een slok genomen."
    },
    {
      "word": "Tsjoch",
      "pronounce": "[Tsjoch]",
      "wordtype": "ynterjeksje",
      "description": "Wurdt útsprutsen by it befêstigjen fan de heilwinsk mei in heildronk, dat wol sizze dat men drinkt op immens wolwêzen, wêrûnder de goede sûnens. Dêrnei wurdt de heildronk befêstige troch it glês te heffen of troch te klinken; it folle eigen drinkglês earst tsjin in oarmans folle glês te tikjen. Der wurdt ûnder it útsprekken fan it wurd 'tsjoch' in slok nommen."
    },
    {
      "word": "Pake",
      "pronounce": "[Pa-ku]",
      "wordtype": "haadwurd",
      "description": "De man dêr 't men alles fan leare kin, dy 't yn elke situaasje ried wit en altyd passende wiisheid paraat hat. Hy kin alles reparearje, wat sels heit net koe. Hy hâldt mear fan syn bernsbern as fan wat dan ek. Hy hat de gekste ideeën en is de grutste grapmakker. Foar de hiele famylje is er in boarne fan leafde en burgenheid."
    },
    {
      "word": "Sister",
      "pronounce": "[Sis-ter]",
      "wordtype": "noun",
      "description": "A woman with the same father and/or mother, protector, the one who shares a bond no one else understands, a keeper of secrets, always ready to help, through thick and thin. A best friend for life who is loved more than she will ever know."
    },
    {
      "word": "Uncle",
      "pronounce": "[Un-cle]",
      "wordtype": "noun",
      "description": "Someone who helps you get into mischief and will never fail to make you smile, the advice giver, the help and the protector, a source of unlimited fun and laughter. The one who is patient, generous and kind, a man who is appreciated and loved."
    },
    {
      "word": "Harré",
      "pronounce": "[Ha-ré]",
      "wordtype": "groet",
      "description": "Hallo, hoi, tot ziens enzovoort. De oorsprong van dit typische Bolswarder woord is niet bekend. Het wordt al een aantal generaties in Bolsward gebruikt, met name door de mensen die 'Bolserters' (Stadsfries) spreken."
    },
    {
      "word": "(A) Goeie",
      "pronounce": "[(A) Koejuh]",
      "wordtype": "groet",
      "description": "Friese taal voor 'goedendag'. Eveneens vervangend gebruik voor 'moarn' (goedemorgen) & 'goejûn' (goedenavond). Een korte doch warme & vertrouwde groet in Friesland."
    },
    {
      "word": "Ewa",
      "pronounce": "[E-wa]",
      "wordtype": "tussenwerpsel",
      "description": "(straattaal) Begroeting met de strekking 'hoe is het?' of 'wat is er?'"
    },
    {
      "word": "Good te pas(se)",
      "pronounce": "[Good te pas(se)]",
      "wordtype": "vraag",
      "description": "De vraag Good te pas(se)? is in Overijssel een begroetingsvorm vergelijkbaar met 'Hoe gaat het?'"
    },
    {
      "word": "Hoi",
      "pronounce": "[Hoi]",
      "wordtype": "uitroep",
      "description": "Hoi is een informele uitroep in het Nederlands. Het wordt zowel gebruikt om iemand te groeten als om vreugde te uiten. In eerste instantie werd hoi alleen gebruikt om te begroeten, later ook als afscheidsgroet."
    },
    {
      "word": "Dream",
      "pronounce": "[Dream]",
      "wordtype": "noun",
      "description": "A world you enter during your sleep, in which you encounter no limitations other than your own imagination."
    },
    {
      "word": "Friends",
      "pronounce": "[Friends]",
      "wordtype": "noun",
      "description": "People who come to your house, eat all your food, drink all your wine and make you laugh till you've peed your pants."
    },
    {
      "word": "Houdoe",
      "pronounce": "[Hou-doe]",
      "wordtype": "groet",
      "description": "Houdoe (met klemtoon op de eerste lettergreep) is een Brabants woord dat in grote delen van Noord-Brabant, het zuiden van Gelderland, Limburg en in delen van noord Antwerpen gebruikt wordt als afscheidsgroet."
    },
    {
      "word": "It giet oan!",
      "pronounce": "[It-giet-oan]",
      "wordtype": "uitroep",
      "description": "(Fries, letterlijk 'het gaat aan') legendarische, vaak geciteerde woorden waarmee Henk Kroes, voormalig voorzitter van de Koninklijke Vereniging De Friesche Elf Steden, in 1997 het doorgaan van de vijftiende Elfstedentocht aankondigde."
    },
    {
      "word": "It kin net!",
      "pronounce": "[It-kin-net]",
      "wordtype": "uitroep",
      "description": "(Fries, letterlijk 'het kan niet') deze zin werd gebruikt in een Nederlandse reclame voor Sonnema Berenburg. In de reclame zien we 2 naïeve Nederlanders die aan Friese boer vragen of het ijs dik genoeg is om op te lopen. De boer antwoordt 'it kin net' wat ontzettend veel lijkt op 'het kan net.' De uitkomst kun je al raden – de Nederlanders stappen het ijs op en zakken er gelijk doorheen."
    },
    {
      "word": "Koekenbakker",
      "pronounce": "[Koe-ken-bak-ker]",
      "wordtype": "zelfstandig naamwoord",
      "description": "Een koekenbakker is iemand met weinig kennis van zaken of die ondeskundig is. Een koekenbakker kan in veel gevallen zelfs geen koeken bakken. Vroeger vond men het bereiden van zoetigheden onwaardig werk voor een man. Zodoende is het scheldwoord koekenbakker ontstaan."
    },
    {
      "word": "Lawyer",
      "pronounce": "['loier]",
      "wordtype": "noun",
      "description": "Someone who does precision guesswork based on unreliable data provided by those of questionable knowledge. Also someone who writes a 10.000 word document and calls it a 'brief'."
    },
    {
      "word": "Moi",
      "pronounce": "['moi]",
      "wordtype": "groet",
      "description": "Moi is de alledaagse groet waarmee bewoners van de noordelijke en oostelijke provincies van Nederland, ofwel de streken waar Nedersaksische dialecten worden gesproken, elkaar begroeten."
    },
    {
      "word": "Oelewapper",
      "pronounce": "['oe-lè-wap-per]",
      "wordtype": "zelfstandig naamwoord",
      "description": "Een oelewapper is iemand die zich opvallend dom of onnozel gedraagt. In de regel heeft het weinig met wapperen te maken en al helemaal niets met oele. Men zegt dat het woord is ontstaan in de Tachtig Jarige oorlog, waar Spaanse soldaten tegen dames 'ol é guapa' zeiden. Dit is in het Nederlands verbasterd naar oelewapper."
    },
    {
      "word": "Oliebol",
      "pronounce": "['o-lie-bol]",
      "wordtype": "zelfstandig naamwoord",
      "description": "Wanneer het woord oliebol niet bedoeld wordt om een vettige, zoete, kleffe bal van gefrituurd deeg aan te duiden, bedoelt men zoveel te zeggen als: sukkel, onhandigerd, domoor."
    },
    {
      "word": "Makelaar",
      "pronounce": "['ma-ke-laar]",
      "wordtype": "zelfstandig naamwoord",
      "description": "Een makelaar is iemand die bemiddelt tussen de koper en de verkoper van een zaak of een persoon. Hij of zij treedt daarbij op als taxateur en onderhandelaar. In de meeste gevallen bemiddelt de makelaar tussen de kopers en verkopers van een woning, maar het kan ook om een bedrijfspand of zelfs personen, zoals profstandaardballers gaan. De makelaar bepaalt de waarde van het te verkopen object, waarbij er ook gelet wordt op de bouwkundige kwaliteit."
    },
    {
      "word": "Padel",
      "pronounce": "[Pà-del]",
      "wordtype": "zelfstandig naamwoord",
      "description": "Een verslavend spelletje in een kooi waar snelheid, teamwork en een vleugje chaos samenkomen. Gespeeld met een racket zonder snaren, een bal die altijd nét anders stuitert dan je verwacht en tegenstanders die elke rally willen winnen. Ideaal voor iedereen die sportief wil doen én tussendoor wil lachen."
    },
    {
      "word": "Pensionado",
      "pronounce": "[Pen-si-o-na-do]",
      "wordtype": "zelfstandig naamwoord",
      "description": "Informele benaming voor een gepensioneerde. Van Oorsprong met name bedoeld als aanduiding voor een (vaak welgestelde) gepensioneerde die een deel van het jaar in een zonovergoten land als overwinteraar van zijn pensioen geniet, met behoud van het Nederlandse pensioen."
    },
    {
      "word": "Physiotherapist",
      "pronounce": "[Phy-si-o-the-ra-pist]",
      "wordtype": "noun",
      "description": "A creative investigator who tailors intervention to your needs, transforming your life and pivoting to promote continual progress, grows your tenacity and endurance while providing riveting conversation and a listening ear. <br/><br/>See also: Superhero"
    },
    {
      "word": "Vrienden",
      "pronounce": "[vrien-den]",
      "wordtype": "bijvoeglijk naamwoord",
      "description": "Mensen die bij je thuis komen, al je eten opeten, al je wijn op drinken en je aan het lachen maken tot je in je broek hebt geplast."
    },
    {
      "word": "Ouwe seun",
      "pronounce": "[ouwe-seun]",
      "wordtype": "Locofaulisme",
      "description": "Harlingers spreken een ieder aan met het woord 'seun' (vrij vertaald 'zoon'). 'Ouwe seun' is de aanspreekvorm voor geboren Harlingers. Vandaar dat Harlingers in Friesland ook bekendstaan als ouwe seunen."
    },
    {
      "word": "Grandparents",
      "pronounce": "[grand-par-ents]",
      "wordtype": "noun",
      "description": "Being like parents, but without all the rules. They always lend a listening ear and are always by your side with good advice. They are secret financiers and great storytellers. You can learn a lot from them."
    },
    {
      "word": "Grootouders",
      "pronounce": "[groot-ou-ders]",
      "wordtype": "zelfstandig naamwoord",
      "description": "Zijn als ouders, maar zonder alle regels. Ze bieden altijd een luisterend oor en staan ​​altijd aan je zijde met goed advies. Het zijn geheime financiers en geweldige verhalenvertellers. Je kunt veel van ze leren."
    },
    {
      "word": "Mem",
      "pronounce": "[Mem]",
      "wordtype": "haadwurd",
      "description": "De frou dy 't fan dyn berte ôf sûnder betingst fan dy hâldt. Dejinge dy 't har bern foar harsels stelt. Se is leaf, geduldich en waarm. Hja is de makker en bewarder fan dierbere oantinkens en dejinge dêr 't men altyd op rekkenje kin."
    },
    {
      "word": "Mom",
      "pronounce": "[Mom]",
      "wordtype": "noun",
      "description": "The woman who loves you unconditionally from birth. The one who puts her children before herself. She is kind, patient and warm. She is the maker and keeper of precious memories and the one who you can always count on above everyone else."
    },
    {
      "word": "Pake & beppe",
      "pronounce": "[pa-ku & bè-pu]",
      "wordtype": "",
      "description": "Binne as âlden, mar sûnder alle regels. Se biede altyd in harkjend ear en steane altyd oan dyn side mei goed advys. It binne geheime finansiers en geweldige ferhalefertellers. Je kinne in soad fan se leare."
    },
    {
      "word": "Vake",
      "pronounce": "[va-ku]",
      "wordtype": "zelfstandig naamwoord",
      "description": "De man die altijd weet hoe het moet, zelfs als ge het zelf nog niet wist. Met eelt op z'n handen en een hart zo zacht als boter. Altijd paraat met een goeie raad, een flauwe mop of een stevige knuffel. Een echte stille werker, die meer geeft dan hij vraagt. <br/><br/>Onze held, zonder cape — maar met een goeie tas koffie in de hand."
    },
    {
      "word": "Bouwvakker",
      "pronounce": "[Bouw-vak-ker]",
      "wordtype": "zelfstandig naamwoord",
      "description": "Een held(in) in fluorescerend werktenue. De maker van alles wat stevig staat en heel blijft, zelfs als jij het gebruikt. Iemand die vroeg opstaat, hard werkt en ondertussen altijd tijd heeft voor een grap of bak koffie. De meester van meetlint, beton en doorzettingsvermogen. Zonder bouwvakker staat de wereld letterlijk stil."
    },
    {
      "word": "Collega",
      "pronounce": "[co-lle-ga]",
      "wordtype": "zelfstandig naamwoord",
      "description": "Persoon die altijd klaarstaat, kennis deelt en zorgt voor gezelligheid.<br><br>Zie ook: vriend, steunpilaar, legende."
    },
    {
      "word": "Legende",
      "pronounce": "[le-gen-de]",
      "wordtype": "zelfstandig naamwoord",
      "description": "Persoon die onmogelijk te vervangen is, maar waarvan HR toch denkt dat het lukt."
    },
    {
      "word": "Geslaagd",
      "pronounce": "[ge-slaagd]",
      "wordtype": "bijvoeglijk naamwoord",
      "description": "Persoon die na jaren van lessen, toetsen, presentaties, deadlines en de nodige stress eindelijk het verlossende woord heeft gehoord: geslaagd."
    },
    {
      "word": "Diploma",
      "pronounce": "[di-plo-ma]",
      "wordtype": "zelfstandig naamwoord",
      "description": "Waardevol document dat bewijst dat alle uren leren, stampen, samenvatten en soms last-minute blokken niet voor niets zijn geweest."
    },
    {
      "word": "Doorzetter",
      "pronounce": "[door-zet-ter]",
      "wordtype": "zelfstandig naamwoord",
      "description": "Iemand die moeilijke opdrachten, vroege lessen en eindeloze deadlines wist te overleven zonder op te geven."
    },
    {
      "word": "Trots",
      "pronounce": "[trots]",
      "wordtype": "bijvoeglijk naamwoord",
      "description": "Het warme gevoel dat ontstaat wanneer iemand iets bereikt waar hard voor is gewerkt. Vaak zichtbaar als een glimlach, soms met een traan. Komt voor bij ouders, kinderen, collega's, vrienden en iedereen die ziet hoeveel inzet, doorzettingsvermogen en lef ergens voor nodig waren."
    },
    {
      "word": "Toekomst",
      "pronounce": "[toe-komst]",
      "wordtype": "zelfstandig naamwoord",
      "description": "Iets waar na het slagen vol vertrouwen naar uitgekeken mag worden, al is het ook prima om eerst even vakantie te vieren."
    }
  ]
}
